import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { InitialState, Action } from "./interface";

import { getPermissions } from "src/api/iam";

export const fetchPermissions = createAsyncThunk(
  "user/getPermissions",
  ({ userEmail }: { userEmail: string }) => getPermissions({ userEmail })
);

export const initialState: InitialState = {
  isLoggedIn: false,
  user: null,
  accessToken: undefined,
  sessionToken: undefined,
  idToken: undefined,
  configuration: undefined,
  permissions: [],
  error: false,
  permissionsError: false
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state: InitialState, action: Action) {
      const { user, isLoggedIn, accessToken, idToken } = action.payload;
      localStorage.setItem("access_token", accessToken);
      localStorage.setItem("id_token", idToken);
      state.user = user;
      state.isLoggedIn = isLoggedIn;
      state.accessToken = accessToken;
      state.idToken = idToken;
    },
    setError(state: InitialState, action: Action) {
      state.error = action.payload;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPermissions.fulfilled, (state, { payload }) => {
        const data = payload.data;
        state.sessionToken = data ? data["session-token"] : "";
        state.configuration = data ? data.roleName : "";
        state.permissions = data ? data?.permissions : [];
        state.permissionsError = false;
      })
      .addCase(fetchPermissions.rejected, (state) => {
        state.permissionsError = true;
      });
  }
});

export const { setUser, setError } = userSlice.actions;

export const selectLoggedInStatus = ({ user }: { user: InitialState }) =>
  user.isLoggedIn;

export const selectUserAccessToken = ({ user }: { user: InitialState }) =>
  user.accessToken;

export const selectUserSessionToken = ({ user }: { user: InitialState }) =>
  user.sessionToken;

export const selectUserconfiguration = ({ user }: { user: InitialState }) =>
  user.configuration;

export const selectPermissions = ({ user }: { user: InitialState }) =>
  user.permissions;

export const selectUserRole = ({ user }: { user: InitialState }) =>
  user.configuration;

export const selectUser = ({ user }: { user: InitialState }) => user.user;

export default userSlice.reducer;
